import React, { useEffect, useState } from "react";
import documentationScript from "./documentationScript.json";
import Container from "@mui/material/Container";

import {
  SampleUserTable,
  AuthorizationCodeFlowTable,
  AuthorizationPKCETable,
  AuthorizatioStep2Table,
  GetCoverageTable,
  GetCoverageIDTable,
  GetExplanationOfBenefitTable,
  GetExplanationOfBenefitIDTable,
  GetPatientTable,
  GetPatientIDTable,
  GetConditionTable,
  GetConditionIDTable,
  GetEncounterTable,
  GetEncounterIDTable,
  GetMedicationDispenseTable,
  GetMedicationDispenseIDTable,
  GetMedicationRequestTable,
  GetMedicationRequestIDTable,
  GetObservationTable,
  GetObservationIDTable,
  GetProcedureTable,
  GetProcedureIDTable,
  GetImmunizationTable,
  GetImmunizationIDTable,
  GetHealthcareServiceTable,
  GetHealthcareServiceIDTable,
  GetOrganizationTable,
  GetOrganizationIDTable,
  GetLocationTable,
  GetLocationIDTable,
  GetPractitionerTable,
  GetPractitionerIDTable,
  GetPractitionerRoleTable,
  GetPractitionerRoleIDTable,
  GetBasicTable,
  GetMedicationKnowledgeTable,
  GetInsurancePlanTable,

} from "./DocumentationTables";
import {
  styles,
  StyledH3,
  StyledH4,
  StyledList,
  StyledPTag,
  StyledATag,
  StyledHeader,
  Global,
} from "./styles";
import Sidebar from "./DocumentationNavigation/Sidebar";
import BottomNavigation from "./DocumentationNavigation/BottomNavigation";
import DocumentationBoldText from "./DocumentationBoldText";
import DocumentationEmail from "./DocumentationEmail";
import { Footer } from "../shared/Footer";
export const Documentation = () => {
  const [matchesMedia, setMatchesMedia] = useState(window.matchMedia("(min-width:1200px)").matches);
  useEffect(() => {
    window
      .matchMedia("(min-width:1200px)")
      .addEventListener("change", (e) => setMatchesMedia(e.matches));
  }, []);

  //Sidebar and Bottom Navigation Bar Active Check
  const [isActiveSidebar, setIsActiveSidebar] = useState("Overview");
  const [isActiveBottomNav, setIsActiveBottomNav] = useState("Overview");

  //useEffect for Active Navigation
  useEffect(() => {
    const sidebarSections = document.querySelectorAll(".headings");
    const bottomNavSections = document.querySelectorAll(".headings");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0) {
            setIsActiveSidebar(entry.target.id);
            setIsActiveBottomNav(entry.target.id);
          }
        });
      },
      { threshold: 0 },
    );
    //observe the section
    sidebarSections.forEach((section) => observer.observe(section));
    bottomNavSections.forEach((section) => observer.observe(section));
    //unobserve the section
    return () => {
      sidebarSections.forEach((section) => observer.unobserve(section));
      bottomNavSections.forEach((section) => observer.unobserve(section));
    };
  }, []);

  //scroll to section (Sidebar)
  const handleSidebar = (id) => {
    document.getElementById(id).scrollIntoView({ behavior: "smooth" });
  };

  //scroll to section (Bottom Navigation Bar)
  const handleBottomNavigationClick = (id) => {
    const bottomNavId = document.getElementById(id);
    const documentationBox = document.getElementById("documentation");
    if (bottomNavId) {
      documentationBox.scrollTo({
        top: bottomNavId.offsetTop,
        behavior: "smooth",
      });
      setIsActiveBottomNav(bottomNavId);
    }
  };

  return (
    <div>
      <Global />
      <Container sx={styles.container}>
        {matchesMedia && (
          <Sidebar
            isActiveSidebar={isActiveSidebar}
            handleSidebar={handleSidebar}
          />
        )}
        {!matchesMedia && (
          <BottomNavigation
            isActiveBottomNav={isActiveBottomNav}
            handleBottomNavigationClick={handleBottomNavigationClick}
          />
        )}

        <Container
          sx={styles.descBox}
          style={{ paddingLeft: "35px" }}
          id="documentation"
        >
          <StyledHeader>Documentation</StyledHeader>

          <StyledH3
            id="Overview"
            className="headings"
          >
            {documentationScript.overview.title}
          </StyledH3>

          <StyledPTag>{documentationScript.overview.paragraph}</StyledPTag>
          <ul>
            <StyledList>
              <DocumentationBoldText
                text={documentationScript.overview.list1}
                boldText={[documentationScript.overview.patientAccessAPI]}
              />
            </StyledList>

            <StyledList>
              <DocumentationBoldText
                text={documentationScript.overview.list2}
                boldText={[documentationScript.overview.providerDirectoryAPI,
                documentationScript.overview.publicBold,
                ]}
              />
              {!!documentationScript.overview.providerDirectoryEndpoint && (
                <StyledPTag style={{ margin: "6px 0 0 0", padding: 0 }}>
                  <StyledATag href={documentationScript.overview.providerDirectoryEndpoint}>
                    {documentationScript.overview.providerDirectoryEndpoint}
                  </StyledATag>
                </StyledPTag>
              )}
            </StyledList>
            <StyledList>
              <DocumentationBoldText
                text={documentationScript.overview.list3}
                boldText={[documentationScript.overview.formularyAPI,
                documentationScript.overview.publicBold,
                ]}
              />
              {!!documentationScript.overview.formularyEndpoint && (
                <StyledPTag style={{ margin: "6px 0 0 0", padding: 0 }}>
                  <StyledATag href={documentationScript.overview.formularyEndpoint}>
                    {documentationScript.overview.formularyEndpoint}
                  </StyledATag>
                </StyledPTag>
              )}
            </StyledList>
          </ul>
          <StyledH3
            id="Getting Started"
            className="headings"
          >
            {documentationScript.getStarted.title}
          </StyledH3>

          <StyledPTag>{documentationScript.getStarted.paragraph}</StyledPTag>

          <StyledH4>{documentationScript.getStarted.sandboxEnv.title} </StyledH4>

          <StyledPTag>{documentationScript.getStarted.sandboxEnv.paragraph1}</StyledPTag>
          <StyledPTag>{documentationScript.getStarted.sandboxEnv.paragraph2}</StyledPTag>

          <ol style={{ listStyleType: "decimal" }}>
            <StyledList>
              <DocumentationBoldText
                text={documentationScript.getStarted.sandboxEnv.list1}
                boldText={[documentationScript.getStarted.sandboxEnv.requestForm]}
              />
            </StyledList>

            <StyledList>
              <DocumentationBoldText
                text={documentationScript.getStarted.sandboxEnv.list2}
                boldText={[documentationScript.getStarted.sandboxEnv.businessDays]}
              ></DocumentationBoldText>
              <DocumentationEmail
                text={documentationScript.getStarted.sandboxEnv.list2Part2}
                styleEmail={documentationScript.getStarted.sandboxEnv.email}
              />
            </StyledList>
            <ul>
              <StyledList>
                <DocumentationBoldText
                  text={documentationScript.getStarted.sandboxEnv.subList1}
                  boldText={[documentationScript.getStarted.sandboxEnv.clientID]}
                ></DocumentationBoldText>
              </StyledList>
              <StyledList>{documentationScript.getStarted.sandboxEnv.subList2}</StyledList>
              <StyledList>{documentationScript.getStarted.sandboxEnv.subList3}</StyledList>
            </ul>
          </ol>

          <StyledH4>{documentationScript.getStarted.sandboxSampleUser.title}</StyledH4>
          <StyledPTag>{documentationScript.getStarted.sandboxSampleUser.paragraph}</StyledPTag>

          {/* SAMPLE USER TABLE  */}
          <SampleUserTable />

          <StyledH4>{documentationScript.getStarted.productionEnv.title}</StyledH4>

          <StyledPTag>
            <DocumentationEmail
              text={documentationScript.getStarted.productionEnv.paragraph}
              styleEmail={documentationScript.getStarted.productionEnv.email}
            />
          </StyledPTag>

          <ol style={{ listStyleType: "decimal" }}>
            <StyledList>
              <DocumentationEmail
                text={documentationScript.getStarted.productionEnv.list1}
                styleEmail={documentationScript.getStarted.productionEnv.email}
              />
            </StyledList>

            <StyledList>{documentationScript.getStarted.productionEnv.list2}</StyledList>

            <StyledList>
              <DocumentationEmail
                text={documentationScript.getStarted.productionEnv.list3}
                styleEmail={documentationScript.getStarted.productionEnv.email}
              />
            </StyledList>
            <ul>
              <StyledList>
                <DocumentationBoldText
                  text={documentationScript.getStarted.productionEnv.subList1}
                  boldText={[documentationScript.getStarted.productionEnv.clientID]}
                />
              </StyledList>
              <StyledList>{documentationScript.getStarted.productionEnv.subList2}</StyledList>
            </ul>
          </ol>

          <StyledH3 id="Authorization" className="headings">
            {documentationScript.authorization.title}
          </StyledH3>

          <StyledPTag>{documentationScript.authorization.paragraph1}</StyledPTag>

          <StyledPTag>
            <DocumentationBoldText
              text={documentationScript.authorization.paragraph2}
              boldText={[
                documentationScript.authorization.paragraph2Bold1, // user/*.read
                documentationScript.authorization.paragraph2Bold2, // fhirUser
              ]}
            />
          </StyledPTag>

          <StyledPTag>
            <DocumentationBoldText
              text={documentationScript.authorization.paragraph3}
              boldText={[documentationScript.authorization.paragraph3Bold1]}
            />
          </StyledPTag>

          {/* Authorization Endpoints sub-section */}
          <StyledH4>{documentationScript.authorization.endpoints.title}</StyledH4>

          <StyledPTag style={{ paddingBottom: 0, marginBottom: 0 }}>
            {documentationScript.authorization.endpoints.sandboxLabel}
          </StyledPTag>

          <ul style={{ marginTop: 6 }}>
            <StyledList>
              <StyledATag href={documentationScript.authorization.endpoints.sandboxUrl}>
                {documentationScript.authorization.endpoints.sandboxUrl}
              </StyledATag>
            </StyledList>
          </ul>

          {/* Authorization Code Flow Table */}
          <AuthorizationCodeFlowTable />

          <StyledPTag style={{ fontWeight: 500, padding: "14px 0px 0px 10px", margin: 0 }}>
            {" "}
            {documentationScript.authorization.codeFlow.paragraph2}{" "}
          </StyledPTag>
          <StyledPTag style={{ padding: "0px 0px 0px 10px", margin: 0 }}>
            {" "}
            {documentationScript.authorization.codeFlow.paragraph3}{" "}
          </StyledPTag>
          <StyledPTag
            style={{ padding: "0px 0px 16px 10px", margin: 0, overflowWrap: "break-word" }}
          >
            {" "}
            <StyledATag
              href={documentationScript.authorization.codeFlow.exampleURL}
              style={{ padding: 0, margin: 0 }}
            >
              {" "}
              {documentationScript.authorization.codeFlow.exampleURL}{" "}
            </StyledATag>
          </StyledPTag>

          <StyledH4>{documentationScript.authorization.pkce.title}</StyledH4>
          <StyledPTag>{documentationScript.authorization.pkce.paragraph1}</StyledPTag>

          {/* Authorization PKCE Table */}
          <AuthorizationPKCETable />

          <StyledPTag style={{ fontWeight: 500, padding: "14px 0px 0px 10px", margin: 0 }}>
            {" "}
            {documentationScript.authorization.pkce.paragraph2}{" "}
          </StyledPTag>
          <StyledPTag style={{ padding: "0px 0px 0px 10px", margin: 0 }}>
            {" "}
            {documentationScript.authorization.pkce.paragraph3}{" "}
          </StyledPTag>
          <StyledPTag
            style={{ padding: "0px 0px 16px 10px", margin: 0, overflowWrap: "break-word" }}
          >
            {" "}
            <StyledATag href={documentationScript.authorization.pkce.exampleURL}>
              {" "}
              {documentationScript.authorization.pkce.exampleURL}{" "}
            </StyledATag>
          </StyledPTag>

          <StyledH4>{documentationScript.authorization.step1.title}</StyledH4>
          <StyledPTag>{documentationScript.authorization.step1.paragraph}</StyledPTag>

          <StyledH4>{documentationScript.authorization.step2.title}</StyledH4>
          <StyledPTag>{documentationScript.authorization.step2.paragraph1}</StyledPTag>
          <StyledPTag>
            {documentationScript.authorization.step2.paragraph2}{" "}
            <StyledATag
              href={documentationScript.authorization.step2.tokenPOST}
              style={{ padding: 0, margin: 0, overflowWrap: "break-word" }}
            >
              {" "}
              {documentationScript.authorization.step2.tokenPOST}{" "}
            </StyledATag>{" "}
          </StyledPTag>
          <StyledPTag>{documentationScript.authorization.step2.paragraph3}</StyledPTag>
          <StyledPTag>{documentationScript.authorization.step2.paragraph4}</StyledPTag>
          {/* Authorization STEP 2 TABLE */}
          <AuthorizatioStep2Table />

          {/* Patient Access */}
          <StyledPTag>
            <DocumentationBoldText
              text={documentationScript.authorization.step2.paragraph5}
              boldText={[
                documentationScript.authorization.step2.paragraph5Bold1,
                documentationScript.authorization.step2.paragraph5Bold2,
                documentationScript.authorization.step2.paragraph5Bold3,
                documentationScript.authorization.step2.paragraph5Bold4,
                documentationScript.authorization.step2.paragraph5Bold5,
              ]}
            />
          </StyledPTag>

          <StyledPTag>
            <DocumentationBoldText
              text={documentationScript.authorization.step2.paragraph6}
              boldText={[
                documentationScript.authorization.step2.paragraph6Bold1,
                documentationScript.authorization.step2.paragraph6Bold2,
                // optional:
                // "parameter refresh_token",
                // "refresh_token",
              ]}
            />
          </StyledPTag>

          <StyledH3 id="Patient Access" className="headings">
            {documentationScript.patientAccess.title}
          </StyledH3>

          {/* FHIR Server Endpoints */}
          <StyledH4>{documentationScript.patientAccess.fhirServerEndpoints.title}</StyledH4>
          <StyledPTag style={{ paddingBottom: 0, margin: 0 }}>
            {documentationScript.patientAccess.fhirServerEndpoints.paragraph}
          </StyledPTag>
          <StyledPTag style={{ padding: "0", margin: 0 }}>
            <StyledATag href={documentationScript.patientAccess.fhirServerEndpoints.sandboxEndpoint}>
              {documentationScript.patientAccess.fhirServerEndpoints.sandboxEndpoint}
            </StyledATag>

          </StyledPTag>
          {/* Coverage */}
          <StyledH4>{documentationScript.patientAccess.coverage.title}</StyledH4>
          <StyledPTag>{documentationScript.patientAccess.coverage.paragraph} </StyledPTag>
          <StyledH4>{documentationScript.patientAccess.getCoverage.title}</StyledH4>
          <StyledPTag>{documentationScript.patientAccess.getCoverage.paragraph} </StyledPTag>
          {/* Get Coverage Table */}
          <GetCoverageTable />

          <StyledH4>{documentationScript.patientAccess.getCoverageID.title}</StyledH4>
          <StyledPTag>{documentationScript.patientAccess.getCoverageID.paragraph} </StyledPTag>
          {/* Get Coverage ID Table */}
          <GetCoverageIDTable />

          {/* Explanation of Benefit */}
          <StyledH4>{documentationScript.patientAccess.benefitExplanation.title}</StyledH4>
          <StyledPTag>{documentationScript.patientAccess.benefitExplanation.paragraph} </StyledPTag>
          <StyledH4>{documentationScript.patientAccess.getBenefitExplanation.title}</StyledH4>
          <StyledPTag>
            {documentationScript.patientAccess.getBenefitExplanation.paragraph}{" "}
          </StyledPTag>
          {/* Get Benefit Explanation Table */}
          <GetExplanationOfBenefitTable />
          <StyledH4>{documentationScript.patientAccess.getBenefitExplanationID.title}</StyledH4>
          <StyledPTag>
            {documentationScript.patientAccess.getBenefitExplanationID.paragraph}{" "}
          </StyledPTag>
          {/* Get Benefit Explanation ID Table */}
          <GetExplanationOfBenefitIDTable />

          {/*Patient */}
          <StyledH4>{documentationScript.patientAccess.patient.title}</StyledH4>
          <StyledPTag>{documentationScript.patientAccess.patient.paragraph} </StyledPTag>
          <StyledH4>{documentationScript.patientAccess.getPatient.title}</StyledH4>
          <StyledPTag>{documentationScript.patientAccess.getPatient.paragraph} </StyledPTag>
          {/* Get Patient Table */}
          <GetPatientTable />
          <StyledH4>{documentationScript.patientAccess.getPatientID.title}</StyledH4>
          <StyledPTag>{documentationScript.patientAccess.getPatientID.paragraph} </StyledPTag>
          {/* Get Patient ID Table */}
          <GetPatientIDTable />

          {/* Condition */}
          <StyledH4>{documentationScript.patientAccess.condition.title}</StyledH4>
          <StyledPTag>{documentationScript.patientAccess.condition.paragraph} </StyledPTag>
          <StyledH4>{documentationScript.patientAccess.getCondition.title}</StyledH4>
          <StyledPTag>{documentationScript.patientAccess.getCondition.paragraph} </StyledPTag>
          {/* Get Condition Table */}
          <GetConditionTable />
          <StyledH4>{documentationScript.patientAccess.getConditionID.title}</StyledH4>
          <StyledPTag>{documentationScript.patientAccess.getConditionID.paragraph} </StyledPTag>
          {/* Get Condition ID Table */}
          <GetConditionIDTable />

          {/* Encounter */}
          <StyledH4>{documentationScript.patientAccess.encounter.title}</StyledH4>
          <StyledPTag>{documentationScript.patientAccess.encounter.paragraph} </StyledPTag>
          <StyledH4>{documentationScript.patientAccess.getEncounter.title}</StyledH4>
          <StyledPTag>{documentationScript.patientAccess.getEncounter.paragraph} </StyledPTag>
          {/* Get Encounter Table */}
          <GetEncounterTable />
          <StyledH4>{documentationScript.patientAccess.getEncounterID.title}</StyledH4>
          <StyledPTag>{documentationScript.patientAccess.getEncounterID.paragraph} </StyledPTag>
          {/* Get Encounter ID Table */}
          <GetEncounterIDTable />

          {/* Medication Dispense */}
          <StyledH4>{documentationScript.patientAccess.medicationDispense.title}</StyledH4>
          <StyledPTag>
            <DocumentationBoldText
              text={documentationScript.patientAccess.medicationDispense.paragraph}
              boldText={[
                documentationScript.patientAccess.medicationDispense.medicationProduct,
                documentationScript.patientAccess.medicationDispense.dispensed,
              ]}
            />
          </StyledPTag>
          <StyledH4>{documentationScript.patientAccess.getMedicationDispense.title}</StyledH4>
          <StyledPTag>
            {documentationScript.patientAccess.getMedicationDispense.paragraph}{" "}
          </StyledPTag>
          {/* Get Medication Dispense Table */}
          <GetMedicationDispenseTable />
          <StyledH4>{documentationScript.patientAccess.getMedicationDispenseID.title}</StyledH4>
          <StyledPTag>
            {documentationScript.patientAccess.getMedicationDispenseID.paragraph}{" "}
          </StyledPTag>
          {/* Get Medication Dispense ID Table */}
          <GetMedicationDispenseIDTable />

          {/* Medication Request */}
          <StyledH4>{documentationScript.patientAccess.medicationRequest.title}</StyledH4>
          <StyledPTag>
            <DocumentationBoldText
              text={documentationScript.patientAccess.medicationRequest.paragraph}
              boldText={[
                documentationScript.patientAccess.medicationRequest.orderOrRequest,
                documentationScript.patientAccess.medicationRequest.supplyOfMedication,
                documentationScript.patientAccess.medicationRequest.insuranceForAdmin,
              ]}
            />
          </StyledPTag>
          <StyledH4>{documentationScript.patientAccess.getMedicationRequest.title}</StyledH4>
          <StyledPTag>
            {documentationScript.patientAccess.getMedicationRequest.paragraph}{" "}
          </StyledPTag>
          {/* Get Medication Request Table */}
          <GetMedicationRequestTable />
          <StyledH4>{documentationScript.patientAccess.getMedicationRequestID.title}</StyledH4>
          <StyledPTag>
            {documentationScript.patientAccess.getMedicationRequestID.paragraph}{" "}
          </StyledPTag>
          {/* Get Medication Request ID Table */}
          <GetMedicationRequestIDTable />

          {/* Observation*/}
          <StyledH4>{documentationScript.patientAccess.observation.title}</StyledH4>
          <StyledPTag>
            <DocumentationBoldText
              text={documentationScript.patientAccess.observation.paragraph}
              boldText={[
                documentationScript.patientAccess.observation.measurements,
                documentationScript.patientAccess.observation.assertions,
                documentationScript.patientAccess.observation.structuredCollections,
              ]}
            />{" "}
          </StyledPTag>
          <StyledH4>{documentationScript.patientAccess.getObservation.title}</StyledH4>
          <StyledPTag>{documentationScript.patientAccess.getObservation.paragraph} </StyledPTag>
          {/* Get Observation Table */}
          <GetObservationTable />
          <StyledH4>{documentationScript.patientAccess.getObservationID.title}</StyledH4>
          <StyledPTag>{documentationScript.patientAccess.getObservationID.paragraph} </StyledPTag>
          {/* Get Observation ID Table */}
          <GetObservationIDTable />

          {/* Procedure*/}
          <StyledH4>{documentationScript.patientAccess.procedure.title}</StyledH4>
          <StyledPTag>{documentationScript.patientAccess.procedure.paragraph} </StyledPTag>
          <StyledH4>{documentationScript.patientAccess.getProcedure.title}</StyledH4>
          <StyledPTag>{documentationScript.patientAccess.getProcedure.paragraph} </StyledPTag>
          {/* Get Procedure Table */}
          <GetProcedureTable />
          <StyledH4>{documentationScript.patientAccess.getProcedureID.title}</StyledH4>
          <StyledPTag>{documentationScript.patientAccess.getProcedureID.paragraph} </StyledPTag>
          {/* Get Procedure ID Table */}
          <GetProcedureIDTable />

          {/* Immunization*/}
          <StyledH4>{documentationScript.patientAccess.immunization.title}</StyledH4>
          <StyledPTag>
            <DocumentationBoldText
              text={documentationScript.patientAccess.immunization.paragraph}
              boldText={[
                documentationScript.patientAccess.immunization.vaccine,
                documentationScript.patientAccess.immunization.immunization,
              ]}
            />{" "}
          </StyledPTag>
          <StyledH4>{documentationScript.patientAccess.getImmunization.title}</StyledH4>
          <StyledPTag>{documentationScript.patientAccess.getImmunization.paragraph} </StyledPTag>
          {/* Get Immunization Table */}
          <GetImmunizationTable />
          <StyledH4>{documentationScript.patientAccess.getImmunizationID.title}</StyledH4>
          <StyledPTag>{documentationScript.patientAccess.getImmunizationID.paragraph} </StyledPTag>
          {/* Get Immunization ID Table */}
          <GetImmunizationIDTable />

          {/* Provider Directory */}
          <StyledH3
            id="Provider Directory"
            className="headings"
          >
            {documentationScript.providerDirectory.title}
          </StyledH3>
          {/* Healthcare Service */}
          <StyledH4>{documentationScript.providerDirectory.healthcareService.title}</StyledH4>
          <StyledPTag>
            {documentationScript.providerDirectory.healthcareService.paragraph}{" "}
          </StyledPTag>
          <StyledH4>{documentationScript.providerDirectory.getHealthcareService.title}</StyledH4>
          <StyledPTag>
            {documentationScript.providerDirectory.getHealthcareService.paragraph}{" "}
          </StyledPTag>
          {/* Get Healthcare Service Table */}
          <GetHealthcareServiceTable />
          <StyledH4>{documentationScript.providerDirectory.getHealthcareServiceID.title}</StyledH4>
          <StyledPTag>
            {documentationScript.providerDirectory.getHealthcareServiceID.paragraph}{" "}
          </StyledPTag>
          {/* Get Healthcare Service ID Table */}
          <GetHealthcareServiceIDTable />

          {/* Organization */}
          <StyledH4>{documentationScript.providerDirectory.organization.title}</StyledH4>
          <StyledPTag>{documentationScript.providerDirectory.organization.paragraph} </StyledPTag>
          <StyledH4>{documentationScript.providerDirectory.getOrganization.title}</StyledH4>
          <StyledPTag>
            {documentationScript.providerDirectory.getOrganization.paragraph}{" "}
          </StyledPTag>
          {/* Get Organization Table */}
          <GetOrganizationTable />
          <StyledH4>{documentationScript.providerDirectory.getOrganizationID.title}</StyledH4>
          <StyledPTag>
            {documentationScript.providerDirectory.getOrganizationID.paragraph}{" "}
          </StyledPTag>
          {/* Get Organization ID Table */}
          <GetOrganizationIDTable />

          {/* Location */}
          <StyledH4>{documentationScript.providerDirectory.location.title}</StyledH4>
          <StyledPTag>{documentationScript.providerDirectory.location.paragraph} </StyledPTag>
          <StyledH4>{documentationScript.providerDirectory.getLocation.title}</StyledH4>
          <StyledPTag>{documentationScript.providerDirectory.getLocation.paragraph} </StyledPTag>
          {/* Get Location Table */}
          <GetLocationTable />
          <StyledH4>{documentationScript.providerDirectory.getLocationID.title}</StyledH4>
          <StyledPTag>{documentationScript.providerDirectory.getLocationID.paragraph} </StyledPTag>
          {/* Get Location ID Table */}
          <GetLocationIDTable />

          {/* Practitioner */}
          <StyledH4>{documentationScript.providerDirectory.practitioner.title}</StyledH4>
          <StyledPTag>{documentationScript.providerDirectory.practitioner.paragraph} </StyledPTag>
          <StyledH4>{documentationScript.providerDirectory.getPractitioner.title}</StyledH4>
          <StyledPTag>
            {documentationScript.providerDirectory.getPractitioner.paragraph}{" "}
          </StyledPTag>
          {/* Get Practitioner Table */}
          <GetPractitionerTable />
          <StyledH4>{documentationScript.providerDirectory.getPractitionerID.title}</StyledH4>
          <StyledPTag>
            {documentationScript.providerDirectory.getPractitionerID.paragraph}{" "}
          </StyledPTag>
          {/* Get Practitioner ID Table */}
          <GetPractitionerIDTable />

          {/* Practitioner Role */}
          <StyledH4>{documentationScript.providerDirectory.practitionerRole.title}</StyledH4>
          <StyledPTag>
            {documentationScript.providerDirectory.practitionerRole.paragraph}{" "}
          </StyledPTag>
          <StyledH4>{documentationScript.providerDirectory.getPractitionerRole.title}</StyledH4>
          <StyledPTag>
            {documentationScript.providerDirectory.getPractitionerRole.paragraph}{" "}
          </StyledPTag>
          {/* Get Practitioner Role Table */}
          <GetPractitionerRoleTable />
          <StyledH4>{documentationScript.providerDirectory.getPractitionerRoleID.title}</StyledH4>
          <StyledPTag>
            {documentationScript.providerDirectory.getPractitionerRoleID.paragraph}{" "}
          </StyledPTag>
          {/* Get Practitioner Role ID Table */}
          <GetPractitionerRoleIDTable />

          {/* Formulary */}
          <StyledH3 id="Formulary" className="headings">
            {documentationScript.formulary.title}
          </StyledH3>

          <StyledH4>{documentationScript.formulary.basic.title}</StyledH4>
          <StyledPTag>{documentationScript.formulary.basic.paragraph}</StyledPTag>

          <StyledH4>{documentationScript.formulary.getBasic.title}</StyledH4>
          <StyledPTag>{documentationScript.formulary.getBasic.paragraph}</StyledPTag>
          <GetBasicTable />

          <StyledH4>{documentationScript.formulary.medicationKnowledge.title}</StyledH4>
          <StyledPTag>{documentationScript.formulary.medicationKnowledge.paragraph}</StyledPTag>

          <StyledH4>{documentationScript.formulary.getMedicationKnowledge.title}</StyledH4>
          <StyledPTag>{documentationScript.formulary.getMedicationKnowledge.paragraph}</StyledPTag>
          <GetMedicationKnowledgeTable />

          <StyledH4>{documentationScript.formulary.insurancePlan.title}</StyledH4>
          <StyledPTag>{documentationScript.formulary.insurancePlan.paragraph}</StyledPTag>

          <StyledH4>{documentationScript.formulary.getInsurancePlan.title}</StyledH4>
          <StyledPTag>{documentationScript.formulary.getInsurancePlan.paragraph}</StyledPTag>
          <GetInsurancePlanTable />

          {/* Privacy and Terms of Service */}
          <StyledH3
            id="Privacy And Terms of Service"
            className="headings"
          >
            {documentationScript.privacyAndTerms.title}
          </StyledH3>
          <StyledPTag>
            {documentationScript.privacyAndTerms.paragraph1}{" "}
            <StyledATag
              href={documentationScript.privacyAndTerms.link1}
              style={{ padding: 0, margin: 0 }}
            >
              {" "}
              {documentationScript.privacyAndTerms.here}
            </StyledATag>
            .
          </StyledPTag>
          <StyledPTag>
            {documentationScript.privacyAndTerms.paragraph2}{" "}
            <StyledATag
              href={documentationScript.privacyAndTerms.link2}
              style={{ padding: 0, margin: 0 }}
            >
              {" "}
              {documentationScript.privacyAndTerms.here}
            </StyledATag>
            .
          </StyledPTag>

          {/* Contact Us */}
          <StyledH3
            id="Contact Us"
            className="headings"
          >
            {documentationScript.contact.title}
          </StyledH3>
          <StyledPTag>
            <DocumentationEmail
              text={documentationScript.contact.paragraph}
              styleEmail={documentationScript.contact.email}
            />
          </StyledPTag>
        </Container>
      </Container>
      {matchesMedia && <Footer />}
    </div>
  );
};
export default Documentation;
